

  export default [
  
    {
      path: "hotelFlight",
      name: "hotelFlight",
      component: () => import("./HotelFlightVoucher")
      
    },
    {
      path: "hotel",
      name: "hotel",
      component: () => import("./HotelVoucher"),
    },
    
    { path: "**", redirect: "/" },
  ];
  